import type { IconType } from 'react-icons';
import {
  LuCoffee,
  LuCupSoda,
  LuMilk,
  LuCandy,
  LuGlassWater,
  LuFilter,
  LuUtensils,
  LuShoppingCart,
  LuPackage,
  LuPrinter,
  LuWifi,
  LuFuel,
  LuCar,
  LuBus,
  LuTicket,
  LuGift,
  LuWrench,
  LuHammer,
  LuNotebookPen,
  LuBookOpen,
  LuLaptop,
  LuMonitor,
  LuPhone,
  LuMail,
  LuSparkles,
  LuDroplets,
  LuLeaf,
  LuPill,
  LuStethoscope,
  LuWallet,
  LuCreditCard,
  LuReceipt,
  LuTags,
  LuBox,
  LuHouse,
  LuBuilding2,
  LuUsers,
  LuCalendar,
} from 'react-icons/lu';

export const TIPO_GASTO_ICONES: { key: string; label: string; Icon: IconType }[] = [
  { key: 'LuCoffee', label: 'Café', Icon: LuCoffee },
  { key: 'LuCupSoda', label: 'Bebida', Icon: LuCupSoda },
  { key: 'LuMilk', label: 'Leite', Icon: LuMilk },
  { key: 'LuCandy', label: 'Açúcar', Icon: LuCandy },
  { key: 'LuGlassWater', label: 'Copo d\'água', Icon: LuGlassWater },
  { key: 'LuFilter', label: 'Filtro', Icon: LuFilter },
  { key: 'LuUtensils', label: 'Alimentação', Icon: LuUtensils },
  { key: 'LuShoppingCart', label: 'Compras', Icon: LuShoppingCart },
  { key: 'LuPackage', label: 'Pacote', Icon: LuPackage },
  { key: 'LuBox', label: 'Caixa', Icon: LuBox },
  { key: 'LuPrinter', label: 'Impressão', Icon: LuPrinter },
  { key: 'LuWifi', label: 'Internet', Icon: LuWifi },
  { key: 'LuFuel', label: 'Combustível', Icon: LuFuel },
  { key: 'LuCar', label: 'Carro', Icon: LuCar },
  { key: 'LuBus', label: 'Transporte', Icon: LuBus },
  { key: 'LuTicket', label: 'Ingresso', Icon: LuTicket },
  { key: 'LuGift', label: 'Presente', Icon: LuGift },
  { key: 'LuWrench', label: 'Manutenção', Icon: LuWrench },
  { key: 'LuHammer', label: 'Ferramenta', Icon: LuHammer },
  { key: 'LuNotebookPen', label: 'Material', Icon: LuNotebookPen },
  { key: 'LuBookOpen', label: 'Livro', Icon: LuBookOpen },
  { key: 'LuLaptop', label: 'Notebook', Icon: LuLaptop },
  { key: 'LuMonitor', label: 'Monitor', Icon: LuMonitor },
  { key: 'LuPhone', label: 'Telefone', Icon: LuPhone },
  { key: 'LuMail', label: 'Correio', Icon: LuMail },
  { key: 'LuSparkles', label: 'Limpeza', Icon: LuSparkles },
  { key: 'LuDroplets', label: 'Água', Icon: LuDroplets },
  { key: 'LuLeaf', label: 'Planta', Icon: LuLeaf },
  { key: 'LuPill', label: 'Farmácia', Icon: LuPill },
  { key: 'LuStethoscope', label: 'Saúde', Icon: LuStethoscope },
  { key: 'LuWallet', label: 'Carteira', Icon: LuWallet },
  { key: 'LuCreditCard', label: 'Cartão', Icon: LuCreditCard },
  { key: 'LuReceipt', label: 'Recibo', Icon: LuReceipt },
  { key: 'LuTags', label: 'Etiquetas', Icon: LuTags },
  { key: 'LuHouse', label: 'Casa', Icon: LuHouse },
  { key: 'LuBuilding2', label: 'Prédio', Icon: LuBuilding2 },
  { key: 'LuUsers', label: 'Pessoas', Icon: LuUsers },
  { key: 'LuCalendar', label: 'Calendário', Icon: LuCalendar },
];

const ICONE_MAP = Object.fromEntries(
  TIPO_GASTO_ICONES.map(({ key, Icon }) => [key, Icon])
) as Record<string, IconType>;

export function resolveTipoGastoIcone(icone?: string | null): IconType | null {
  if (!icone) return null;
  return ICONE_MAP[icone] ?? null;
}
